import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const DownChevron = props => /*#__PURE__*/_jsx(SVGIconBase, Object.assign({}, props, {
  children: /*#__PURE__*/_jsx("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M16.59 20.4c.103-.052.191-.108.273-.173l-.003.003.16-.1h.07l11-10.51c.312-.29.507-.702.507-1.16 0-.873-.708-1.582-1.582-1.582-.416 0-.794.16-1.076.422l.001-.001-9.94 9.47-9.94-9.47c-.289-.311-.701-.504-1.157-.504-.873 0-1.58.707-1.58 1.58 0 .482.215.913.555 1.203l.002.002 11 10.51h.07l.16.1c.079.062.167.118.261.166l.009.004c.083.027.182.048.283.059l.007.001c.087.024.19.042.295.05h.005c.11-.008.213-.026.311-.053l-.011.003.064.001c.09 0 .179-.008.265-.023l-.009.001z"
  })
}));
export default DownChevron;